import React from 'react';
import {
  Checkbox,
  Divider,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
} from '@material-ui/core';
import { Close, Search } from '@material-ui/icons';
import { useTranslation } from '@michelin/central-provider';

interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  resultsCount?: number;
  total: number;
  cellView: boolean;
  placeholder?: string;
  searchWidth?: number | string;
  height?: number | string;
  divider?: boolean;
  disabled?: boolean;
  filterEmpty?: boolean;
  filterEmptyEnabled?: boolean;
  onToggleFilterEmpty?: (checked: boolean) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  resultsCount = 0,
  total,
  cellView = false,
  placeholder,
  searchWidth = 100,
  height = '56px',
  divider = true,
  disabled = false,
  filterEmpty = false,
  filterEmptyEnabled = false,
  onToggleFilterEmpty,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingRight: cellView ? '8px' : '16px',
          paddingLeft: cellView ? '8px' : '16px',
          height,
        }}
      >
        <div>
          <FormControlLabel
            control={(
              <Checkbox
                checked={filterEmpty}
                onChange={(e) => onToggleFilterEmpty?.(e.target.checked)}
                color="primary"
                size="small"
                disabled={!filterEmptyEnabled || disabled}
              />
            )}
            label={cellView ? t('Empty') : t('Only show empty secondary')}
          />
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: cellView ? '4px' : '16px',
          }}
        >
          <div
            style={{
              padding: '0px 10px',
              fontSize: '14px',
              fontStyle: 'italic',
            }}
          >
            {!cellView
              ? t('Listing {{count}} record(s) out of {{total}}', {
                count: resultsCount,
                total,
              })
              : t('{{count}} / {{total}}', {
                count: resultsCount,
                total,
              })}
          </div>

          <TextField
            placeholder={placeholder || t('Search...')}
            value={value}
            disabled={disabled}
            onChange={(e) => {
              const newValue = e.target.value;
              onChange(newValue);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: value ? (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={() => onChange('')}
                    edge="end"
                    disabled={disabled}
                  >
                    <Close fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null,
              style: {
                fontSize: '14px',
                width: searchWidth,
              },
            }}
          />
        </div>
      </div>

      {divider && <Divider />}
    </>
  );
};
